import React from 'react';

import { ELECTRON_TITLE_BAR_HEIGHT } from 'src/constants/uiConsts';
import { isElectron } from 'src/hooks/useElectron';

/**
 * A draggable title bar region for the Electron desktop app.
 * This component renders a fixed bar at the top of the viewport that:
 * 1. Provides a drag region to move the window
 * 2. Creates space for macOS traffic light buttons (close, minimize, maximize)
 *
 * Only renders when running in Electron.
 */
export const ElectronTitleBar: React.FC = () => {
  if (!isElectron()) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: ELECTRON_TITLE_BAR_HEIGHT,
        // This CSS property makes the element draggable in Electron
        // @ts-expect-error - WebkitAppRegion is a non-standard CSS property for Electron
        WebkitAppRegion: 'drag',
        // Ensure it's above other content but below modals
        zIndex: 1000,
        // Transparent so content shows through
        backgroundColor: 'transparent',
        // Prevent pointer events except for dragging
        pointerEvents: 'auto',
      }}
      // Accessibility: this is a non-interactive drag region
      aria-hidden="true"
    />
  );
};
